import req from "../http";

const mailTemplate = {
  // 新增 信件範本
  postMailTemplate(params) {
    return req("post", "/Template/MailTemplate", params);
  },

  // 編輯 信件範本 
  putMailTemplate(params) {
    return req("put", "/Template/MailTemplate", params);
  },

  // 複製 信件範本
  copyMailTemplate(params) {
    return req("post", "/Template/MailTemplate/Copy", params);
  },

  // 刪除 信件範本
  deleteMailTemplate(guid) {
    return req("delete", `/Template/MailTemplate/${guid}`);
  },

  // 依類別 取得信件範本(分頁)
  getMailTemplatePaging(params, category) {
    return req("get", `/Template/MailTemplate/paging/${category}`, params);
  },

  // 依類別guid 取得信件範本參數
  getMailParameter(categoryGuid) {
    return req("get", `/Template/MailParameter/${categoryGuid}`);
  },

  // 依guid 取得信件範本內容
  getMailTemplateDetail(guid) {
    return req("get", `/Template/MailTemplate/Detail/${guid}`);
  },
};

export default mailTemplate;